import React, { useEffect, useMemo } from "react"
import { Chart } from "react-google-charts"
import { makeStyles } from "@material-ui/core"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import _ from "lodash"
import { GRAPH_DATE_OPTIONS } from "../../utils"

const useStyles = makeStyles((theme) => ({
	root: {
		minHeight: 630,
		width: "100%",
		"& div div:nth-child(2) svg:nth-child(1) > rect": {
			fill: "transparent",
		},
	},
	noData: {
		display: "flex",
		justifyContent: "center",
	},
}))
export const options = {
	chartArea: { height: "90%", width: "90%", top: 10, bottom: 70 },
	vAxis: {
		slantedText: false,
		format: "0",
		viewWindow: {
			min: 0,
		},
	},
	hAxis: {
		slantedText: false,
		// format: "yyyy",
		// textStyle: {
		// 	fontSize: 14, // or the number you want
		// },
	},
	legend: { position: "none" },
	animation: {
		startup: true,
		duration: 1000,
		easing: "inAndOut",
	},
	pointSize: 5,
	curveType: "function",
	// datum: {
	// 	type: "string",
	// 	value: new Date("2010-02-26").toString(),
	// },
}

const TimelineGraph = ({ refetchList, selectedGraphDateRange }) => {
	const classes = useStyles()
	const [t] = useTranslation("global")

	const data = useSelector((state) => state.timeline.graph)
	const isLoading = useSelector((state) => state.timeline.graphLoading)

	const memoizedRange = useMemo(() => {
		if (!_.isEmpty(selectedGraphDateRange) && selectedGraphDateRange?.selected === GRAPH_DATE_OPTIONS.SLIDER) {
			const range = selectedGraphDateRange[selectedGraphDateRange?.selected]
			return { range: range }
		}
	}, [selectedGraphDateRange.sliderPicker])

	return (
		<>
			<>
				<div className={classes.root}>
					{isLoading ? (
						<div className={classes.noData}>{t("graph.graphIsLoading")}</div>
					) : data?.length > 1 ? (
						<>
							{/* <div>
								{selectedGraphDateRange?.selected &&
									`Selected Range: ${selectedGraphDateRange[selectedGraphDateRange?.selected].start} - ${
										selectedGraphDateRange[selectedGraphDateRange?.selected].end
									}`}
							</div> */}
							<Chart
								chartType="LineChart"
								width="100%"
								height={"550px"}
								data={data}
								options={options}
								chartPackages={["corechart", "controls"]}
								chartEvents={[
									{
										eventName: "select",
										callback: ({ chartWrapper }) => {
											try {
												const chart = chartWrapper.getChart()
												const selection = chart.getSelection()
												const [selectedItem] = selection
												const { row, column } = selectedItem
												const dataTable = chartWrapper.getDataTable()

												if (selection?.length === 1) {
													let itemDate
													let itemValue
													let numRow = dataTable["ir"][row]
													if (dataTable["Ta"]["Wf"][numRow]) {
														itemDate = dataTable["Ta"]["Wf"][numRow]["c"][0]["v"]
														itemValue = dataTable["Ta"]["Wf"][numRow]["c"][1]["v"]
													}
													if (itemDate) {
														const start = `${itemDate.getFullYear()}-${("0" + (itemDate.getMonth() + 1)).slice(
															-2
														)}-${("0" + itemDate.getDate()).slice(-2)}`

														const end = `${itemDate.getFullYear()}-${("0" + (itemDate.getMonth() + 1)).slice(
															-2
														)}-${("0" + itemDate.getDate()).slice(-2)}`

														if (start && end) {
															refetchList({
																...selectedGraphDateRange,
																graphPicker: { start, end },
																selected: GRAPH_DATE_OPTIONS.GRAPH_PICKER,
															})
														}
													}
												}
											} catch (error) {
												console.log("Error in Graph date selection: ", error)
											}
										},
									},
								]}
								controls={[
									{
										controlType: "ChartRangeFilter",
										options: {
											filterColumnIndex: 0,
											ui: {
												chartType: "LineChart",
												//snapToData: true,
												chartOptions: {
													height: 200,
													chartArea: { width: "90%", height: "50%", top: 5 },
													hAxis: { baselineColor: "none" },
													curveType: "function",
												},
											},
										},
										controlPosition: "bottom",
										controlWrapperParams: {
											// state: {
											// 	//range: { start: data[1][0], end: data[data.length - 1][0] },
											// 	range: _.isEmpty(selectedGraphDateRange)
											// 		? { start: data[1][0], end: data[data.length - 1][0] }
											// 		: memoizedRange,
											// },

											state: memoizedRange,
										},
										controlEvents: [
											{
												eventName: "statechange",
												callback: ({ chartWrapper, controlWrapper }) => {
													try {
														let start = controlWrapper.getState().range.start
														let end = controlWrapper.getState().range.end
														//refetchList({ start, end, selected: GRAPH_DATE_OPTIONS.SLIDER })
														refetchList({
															...selectedGraphDateRange,
															sliderPicker: { start, end },
															graphPicker: { start: "", end: "" },
															selected: GRAPH_DATE_OPTIONS.SLIDER,
														})
													} catch (error) {
														console.log("Error in Graph date range selection: ", error)
													}
												},
											},
										],
									},
								]}
							/>
						</>
					) : (
						<div className={classes.noData}>{t("graph.noRecordsFound")}</div>
					)}
				</div>
			</>
		</>
	)
}

export default React.memo(TimelineGraph)
